<template>
  <div>
    <Blade1></Blade1>
    <Blade1a></Blade1a>
    <Blade2></Blade2>
    <Blade3></Blade3>
    <Factoid></Factoid>
    <Blade4></Blade4>
    <Blade5></Blade5>
    <Blade6></Blade6>
  </div>
</template>

<script>
document.documentElement.setAttribute("data-browser", navigator.userAgent);

import Blade1 from "@/components/Blade1";
import Blade1a from "@/components/Blade1a";
import Blade2 from "@/components/Blade2";
import Blade3 from "@/components/Blade3";
import Blade4 from "@/components/Blade4";
import Blade5 from "@/components/Blade5";
import Blade6 from "@/components/Blade6";
import Factoid from "@/components/Factoid";

export default {
  name: "home",
  components: {
    Blade1,
    Blade1a,
    Blade2,
    Blade3,
    Blade4,
    Factoid,
    Blade5,
    Blade6
  }
};
</script>

<style lang="sass" scoped>

</style>